import * as React from "react";
const SvgFiRrHandMiddleFinger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-middle-finger_svg__a)">
      <path
        fill="#062147"
        d="M17.943 9.376 16 8.985V3c0-1.517-1.076-2.835-2.503-3.066A3 3 0 0 0 10 2.895l.01 4.962h-.02a4.02 4.02 0 0 0-3.537 2.122l-4.417 4.214a3.61 3.61 0 0 0-1.074 2.576 3.61 3.61 0 0 0 1.065 2.58l2.308 2.308A7.95 7.95 0 0 0 9.992 24h6.97c2.757 0 5-2.243 5-5v-4.721a5.014 5.014 0 0 0-4.02-4.903M19.962 19c0 1.654-1.346 3-3 3h-6.97a5.96 5.96 0 0 1-4.243-1.757L3.44 17.935a1.63 1.63 0 0 1-.48-1.162c0-.439.173-.851.47-1.146L6 13.176V17a1 1 0 1 0 2 0v-5.597q.057-.093.095-.199a2.005 2.005 0 0 1 2.286-1.307l.436.087a1 1 0 0 0 1.196-.983L12 2.893a1.002 1.002 0 0 1 1.176-.986c.462.075.824.555.824 1.092v6.805a1 1 0 0 0 .803.98l2.747.552a3.01 3.01 0 0 1 2.412 2.942z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-middle-finger_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandMiddleFinger;
